import * as React from 'react';
import { useDispatch } from 'react-redux';

import { EOrderBy } from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryRequestV4Schema';

import { getOffersHistory, openOfferFromHistory, setPage, setSortOffers } from '../../../../actions/offersHistory';
import { trackFiltersChange } from '../analytics';

/**
 * Хендлер выбора сортировки
 * */
export const useHandleSortOffersChange = () => {
  const dispatch = useDispatch();

  return React.useCallback(
    async (value: EOrderBy) => {
      dispatch(setSortOffers(value));

      dispatch(setPage(1));
      await dispatch(getOffersHistory(false));
      dispatch(trackFiltersChange());
      await dispatch(openOfferFromHistory());
    },
    [dispatch],
  );
};
